import * as React from 'react';
import Field from './Field';
import List from './List';
import useForm from './useForm';
import FieldForm from './Form';
import { FormProvider } from './FormContext';
var InternalForm = React.forwardRef(FieldForm);
var RefForm = InternalForm;
RefForm.FormProvider = FormProvider;
RefForm.Field = Field;
RefForm.List = List;
RefForm.useForm = useForm;
export { Field, List, useForm, FormProvider };
export default RefForm;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-field-form/es/index.js
// module id = 121
// module chunks = 0